import { SitterSearchType } from 'us-web-services';

export interface SitterSearchTypeOption {
  id?: number;
  code: '' | 'OCCASIONAL' | 'FULL_TIME' | 'PART_TIME';
  label: string;
}

export const SITTER_SEARCH_TYPES: SitterSearchTypeOption[] = [
  { code: '', label: 'All' },
  { id: 3, code: 'OCCASIONAL', label: 'Occasional' },
  { id: 2, code: 'FULL_TIME', label: 'Full-time' },
  { id: 1, code: 'PART_TIME', label: 'Part-time' },
];

export const sitterSearchTypeByCode: Record<string, SitterSearchType> =
  SITTER_SEARCH_TYPES.reduce<Record<string, SitterSearchType>>((acc, option) => {
    if (option.id != null && option.code) {
      acc[option.code] = { id: option.id, label: option.label };
    }
    return acc;
  }, {});
